export default __webpack_public_path__ + "static/enjoyye-lap-f76d8d3a90c0d9a557b762750119950b.png";